/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/no-explicit-any */
import jQuery from 'jquery'
import { scriptLoader } from '@mobi/utils/scriptLoader'
import * as CMN from './Common'
import * as NOTE from './Notification'
import dotIcon from './images/blue-dot.png'
import pinShadow from './images/pin-shadow.png'
import sl1Purple from './images/sl1-purple.png'
import sl2Yellow from './images/sl2-yellow.png'
import sl3Red from './images/sl3-red.png'

let getPositionTimeOut: ReturnType<typeof setTimeout>
let geoCodeWatchId: number
let loadingOverlay: JQuery
let currentLocationRequestInProgress: boolean
let canUpdateLocation = true
let newPosition: { coords: { latitude: number; longitude: number } }
let followingGPS = false
let hasGoogleMapsBeenFetched = false

let introNotification: any
let canCentreScreen: boolean

let map: any = null
let googleTabmarkers: any = []
const googleMarkerIcons: any = []

let geocoder: any
let usersGeoLocation: any
let currentGeoLocation: any
let infowindow: any
let iconShadow: any
const sl1CategoryCode = 'SL1'
const sl2CategoryCode = 'SL2'
const sl3CategoryCode = 'SL3'
let currentLocationMarker: any

let markerIconSize: any
let markerAnchor: any
let markerOrigin: any

const slColorDict = {
  ['sl1-purple']: sl1Purple,
  ['sl2-yellow']: sl2Yellow,
  ['sl3-red']: sl3Red,
}

const GOOGLE_MAPS_API_KEY = 'AIzaSyCS2iWIkf3XzqFKGKm1aQY3EJs5svhKn8U'

export async function initPage() {
  // @ts-expect-error No types legacy
  if (!window.TABLocatorWebInit) {
    // @ts-expect-error No types legacy
    window.TABLocatorWebInit = initLocator
  }

  if (hasGoogleMapsBeenFetched) {
    initLocator()
  } else {
    scriptLoader(
      `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&loading=async&callback=TABLocatorWebInit`
    )
    hasGoogleMapsBeenFetched = true
  }
}

function initLocator() {
  loadingOverlay = jQuery('#loading-overlay')
  addHandlers()

  // TODO maybe integrate this with location updates from Venue Mode (TO-80, VT-167)
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (geoLocation) {
      usersGeoLocation = geoLocation

      if (canUpdateLocation) {
        updateLocationOnMap(
          // @ts-expect-error No types legacy
          new google.maps.LatLng(geoLocation.coords.latitude, geoLocation.coords.longitude)
        )
        followingGPS = true
        geoCodeWatchId = navigator.geolocation.watchPosition(handlePositionChange)
        monitorCurrentLocation()
      }
    })

    setTimeout(function () {
      canUpdateLocation = false
    }, 10000)

    loadingOverlay.hide()
  }

  setMapHeight()
  initialize()
  resizeGoogleMap()

  jQuery('#tabtouch-notification, #tablocator-intro-notification').css({
    height: jQuery(document).height(),
  })
}

function setMapHeight() {
  const maxAllowedHeight =
    jQuery(window).height() - jQuery('#tabTypeSelectionContainer').height() - 50
  jQuery('#map_canvas').height(Math.min(600, maxAllowedHeight))
  resizeGoogleMap()
}

function addHandlers() {
  jQuery('#SL1Item').click(function () {
    monitorChangeLocationRequest(function () {
      boxclick('SL1')
    })
  })
  jQuery('#SL2Item').click(function () {
    monitorChangeLocationRequest(function () {
      boxclick('SL2')
    })
  })
  jQuery('#SL3Item').click(function () {
    monitorChangeLocationRequest(function () {
      boxclick('SL3')
    })
  })

  const addressTextBox = jQuery('#address')

  jQuery('#currentLocation').click(function () {
    addressTextBox.val('')
    addressTextBox.blur()
    if (!currentLocationRequestInProgress) {
      currentLocationRequestInProgress = true
      monitorChangeLocationRequest(changeLocationToCurrentLocation)
    }
  })

  const goButton = jQuery('#go_button')

  goButton.click(function () {
    addressTextBox.blur()
    monitorChangeLocationRequest(function () {
      if (!addressTextBox.hasClass('watermark-textbox')) {
        clearLocationWatch()
        followingGPS = false
        const query = addressTextBox.val()

        infowindow.close()
        // @ts-expect-error No types legacy
        geocoder = new google.maps.Geocoder()
        if (jQuery.trim(query).length > 0) {
          const address = query + ', Western Australia, Australia'

          geocoder.geocode(
            {
              address: address,
              partialmatch: true,
            },
            processGeocodeResult
          )
        }
      }
    })
  })

  addressTextBox.keydown(function (e) {
    if (e.keyCode == 13) {
      e.preventDefault()
      goButton.click()
    }
  })

  jQuery(window).resize(handleResize)
}

function handleResize() {
  if (jQuery('#map_canvas').length == 0) {
    jQuery(window).unbind('resize', handleResize)
    return
  }
  setMapHeight()
  jQuery('#tabtouch-notification, #tablocator-intro-notification').css({
    height: jQuery(document).height(),
  })
  loadingOverlay.css({ height: jQuery(document).height() })
}

function changeLocationToCurrentLocation() {
  loadingOverlay.show()
  clearLocationWatch()
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(handleSuccessfulLocationFind)
    clearTimeout(getPositionTimeOut)
    getPositionTimeOut = setTimeout(handleGetCurrentPositionError, 10000)
  }
  loadingOverlay.hide()
}

function clearLocationWatch() {
  navigator.geolocation.clearWatch(geoCodeWatchId)
}

function handleSuccessfulLocationFind(pos: any) {
  currentLocationRequestInProgress = false
  clearTimeout(getPositionTimeOut)
  // @ts-expect-error No types legacy
  updateLocationOnMap(new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude))
  followingGPS = true
  geoCodeWatchId = navigator.geolocation.watchPosition(handlePositionChange)
  monitorCurrentLocation()
}

function handlePositionChange(position: any) {
  newPosition = position
}

function monitorCurrentLocation() {
  if (
    newPosition &&
    (newPosition.coords.latitude !== currentGeoLocation.latitude ||
      newPosition.coords.longitude !== currentGeoLocation.longitude) &&
    !currentLocationRequestInProgress &&
    followingGPS
  ) {
    updateLocationOnMap(
      // @ts-expect-error No types legacy
      new google.maps.LatLng(newPosition.coords.latitude, newPosition.coords.longitude),
      true
    )
  }

  if (jQuery('#map_canvas').length > 0) {
    setTimeout(monitorCurrentLocation, 5000)
  } else {
    navigator.geolocation.clearWatch(geoCodeWatchId)
  }
}

function monitorChangeLocationRequest(callback: () => void) {
  callback()
  loadingOverlay.hide()
}

function handleGetCurrentPositionError() {
  currentLocationRequestInProgress = false
  clearTimeout(getPositionTimeOut)
  CMN.showPopup(jQuery('#tabtouch-notification'))
}

function initialize() {
  // @ts-expect-error No types legacy
  markerIconSize = new google.maps.Size(15, 30)
  // @ts-expect-error No types legacy
  markerAnchor = new google.maps.Point(9, 30)
  // @ts-expect-error No types legacy
  markerOrigin = new google.maps.Point(0, 0)
  canCentreScreen = false
  addWaterMark('address', 'Other Location')
  let position = {
    coords: {
      latitude: -31.9554,
      longitude: 115.85859,
    },
  }
  if (usersGeoLocation) {
    position = usersGeoLocation
  }
  setCurrentLocation(position)
  addToRadFunctionToNumber()
  loadMarkerImages()
  introNotification = NOTE.initTabLocatorNotification(() => {
    canCentreScreen = true
    centreScreenOnMap()
  })

  initGoogleMapObjects()
  createGoogleMap()
  currentLocationMarker = createUsersLocationMarker()

  // Get Locations from File
  downloadUrl('../Content/tab-location.xml', parseXmlFlieForLocations)

  // @ts-expect-error No types legacy
  const latlng = new google.maps.LatLng(currentGeoLocation.latitude, currentGeoLocation.longitude)
  map?.setCenter(latlng)
}

function setCurrentLocation(position: any) {
  if (position.coords) {
    currentGeoLocation = position.coords
  } else if (position.lat) {
    currentGeoLocation = {
      latitude: position.lat(),
      longitude: position.lng(),
    }
  } else {
    currentGeoLocation = position
  }
}

function loadMarkerImages() {
  googleMarkerIcons[sl1CategoryCode] = getMarkerImage(getCssClassForCategory(sl1CategoryCode))
  googleMarkerIcons[sl2CategoryCode] = getMarkerImage(getCssClassForCategory(sl2CategoryCode))
  googleMarkerIcons[sl3CategoryCode] = getMarkerImage(getCssClassForCategory(sl3CategoryCode))
}

function addToRadFunctionToNumber() {
  // @ts-expect-error No type legacy
  if (!Number.prototype.toRad) {
    // @ts-expect-error No type legacy
    Number.prototype.toRad = function () {
      // @ts-expect-error No type legacy
      return (this * Math.PI) / 180
    }
  }
}

function createGoogleMap() {
  const myOptions = {
    panControl: false,
    zoom: 12,
    minZoom: 5,
    maxZoom: 18,
    // @ts-expect-error No types legacy
    center: new google.maps.LatLng(currentGeoLocation.latitude, currentGeoLocation.longitude),
    mapTypeControl: false,
    mapTypeControlOptions: {
      // @ts-expect-error No types legacy
      style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
    },
    streetViewControl: false,
    navigationControl: true,
    // @ts-expect-error No types legacy
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoomControl: true,
    styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
  }

  const mapCanvas = jQuery('#map_canvas')
  // @ts-expect-error No types legacy
  map = new google.maps.Map(mapCanvas[0], myOptions)

  // @ts-expect-error No types legacy
  google.maps.event.addListener(map, 'click', function () {
    infowindow.close()
  })
  // @ts-expect-error No types legacy
  google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
    centreScreenOnMap()
    introNotification.show()
  })
}

function createUsersLocationMarker() {
  // @ts-expect-error No types legacy
  return new google.maps.Marker({
    // @ts-expect-error No types legacy
    position: new google.maps.LatLng(currentGeoLocation.latitude, currentGeoLocation.longitude),
    icon: {
      url: dotIcon,
      // @ts-expect-error No types legacy
      anchor: new google.maps.Point(25, 25),
    },
    map,
    title: name,
    zIndex: 999900000,
  })
}

function parseXmlFlieForLocations(doc: any) {
  const xmlDoc = new DOMParser().parseFromString(doc, 'text/xml')
  const markers = xmlDoc.documentElement.getElementsByTagName('marker')

  googleTabmarkers = []
  for (let i = 0; i < markers.length; i++) {
    const category = markers[i].getAttribute('category')

    const html =
      "<div id='infoWindowContent'>" +
      "<div style='width:220px;'><strong><span>" +
      markers[i].getAttribute('name') +
      "<div style='width:200px;'>" +
      markers[i].getAttribute('address') +
      '</div>' +
      '</div>'

    const lat = markers[i].getAttribute('lat')
    const lng = markers[i].getAttribute('lng')
    // @ts-expect-error No types legacy
    const point = new google.maps.LatLng(lat, lng)
    googleTabmarkers.push(createMarker(point, markers[i].getAttribute('name'), html, category))
  }

  showMarkerForCategory(sl1CategoryCode)
  showMarkerForCategory(sl2CategoryCode)
  showMarkerForCategory(sl3CategoryCode)
}

function getMarkerImage(iconColor: any) {
  if (!iconColor) {
    iconColor = 'default'
  }
  if (!googleMarkerIcons[iconColor]) {
    // @ts-expect-error No types legacy
    googleMarkerIcons[iconColor] = new google.maps.MarkerImage(
      slColorDict[iconColor as keyof typeof slColorDict] || '',
      markerIconSize,
      markerOrigin,
      markerAnchor
    )
  }
  return googleMarkerIcons[iconColor]
}

function getCssClassForCategory(category: any) {
  switch (category) {
    case sl2CategoryCode:
      return 'sl2-yellow'
    case sl3CategoryCode:
      return 'sl3-red'
    default:
      return 'sl1-purple'
  }
}

function createMarker(latlng: any, name: any, html: any, category: any) {
  const contentString = html
  // @ts-expect-error No types legacy
  const marker = new google.maps.Marker({
    position: latlng,
    icon: googleMarkerIcons[category],
    shadow: iconShadow,
    map,
    title: name,
    zIndex: Math.round(latlng.lat() * -100000) << 5,
  })
  marker.mycategory = category
  marker.myname = name

  // @ts-expect-error No types legacy
  google.maps.event.addListener(marker, 'click', function () {
    infowindow.close()
    infowindow.setContent(contentString)
    infowindow.open(map, marker)
  })

  return marker
}

function processGeocodeResult(results: any, status: string) {
  if (status == 'OK' && results.length > 0) {
    updateLocationOnMap(results[0].geometry.location)
  }
}

function updateLocationOnMap(latlng: any, dontGoToMap?: any) {
  setCurrentLocation(latlng)
  currentLocationMarker.setPosition(latlng)

  if (!dontGoToMap) {
    resizeGoogleMap()
    centreScreenOnMap()
    map.setCenter(latlng)
  }
}

function centreScreenOnMap(complete?: any) {
  const anchorOffset = jQuery('#anchor').offset()
  if (canCentreScreen && anchorOffset) {
    jQuery('html:not(:animated),body:not(:animated)').animate(
      { scrollTop: anchorOffset.top },
      'fast',
      undefined,
      complete
    )
  }
}

function resizeGoogleMap() {
  if (map) {
    // @ts-expect-error No types legacy
    google.maps.event.trigger(map, 'resize')
  }
}

function showMarkerForCategory(category: string) {
  for (let i = 0; i < googleTabmarkers.length; i++) {
    if (googleTabmarkers[i].mycategory === category) {
      googleTabmarkers[i].setVisible(true)
    }
  }
  jQuery('#' + category + 'box').prop('checked', true)
}

function boxclick(category: any) {
  let isVisible = false
  for (let i = 0; i < googleTabmarkers.length; i++) {
    if (googleTabmarkers[i].mycategory === category) {
      isVisible = googleTabmarkers[i].getVisible() === false
      googleTabmarkers[i].setVisible(isVisible)
    }
  }
  jQuery('#' + category + 'box').prop('checked', isVisible)
  infowindow.close()
}

function initGoogleMapObjects() {
  // @ts-expect-error No types legacy
  infowindow = new google.maps.InfoWindow({
    maxWidth: 300,
  })

  // @ts-expect-error No types legacy
  google.maps.event.addListener(infowindow, 'clickclose', function () {
    infowindow.close()
  })

  // @ts-expect-error No types legacy
  googleMarkerIcons['default'] = new google.maps.MarkerImage(
    sl1Purple,
    markerIconSize,
    markerOrigin,
    markerAnchor
  )
  /* Marker sizes are expressed as a Size of X,Y
      where the origin of the image (0,0) is located
      in the top left of the image.

      Origins, anchor positions and coordinates of the marker
      increase in the X direction to the right and in
      the Y direction down.*/

  // @ts-expect-error No types legacy
  iconShadow = new google.maps.MarkerImage(
    pinShadow,
    /* The shadow image is larger in the horizontal dimension
      while the position and offset are the same as for the main image. */
    // @ts-expect-error No types legacy
    new google.maps.Size(15, 20),
    // @ts-expect-error No types legacy
    new google.maps.Point(0, 0),
    // @ts-expect-error No types legacy
    new google.maps.Point(1, 15)
  )
}

function addWaterMark(id: string, text: string) {
  const textBox = jQuery('#' + id)
  const waterMarkClass = 'watermark-textbox'

  textBox.val(text).addClass(waterMarkClass)

  textBox.on('blur', () => {
    if (textBox.val().length !== 0) return
    textBox.val(text)
    textBox.addClass(waterMarkClass)
  })

  textBox.on('focus', () => {
    textBox.val('')
    textBox.removeClass(waterMarkClass)
  })
}

/**
 * This functions wraps XMLHttpRequest open/send function.
 * It lets you specify a URL and will call the callback if
 * it gets a status code of 200.
 * @param {String} url The URL to retrieve
 * @param {Function} callback The function to call once retrieved.
 */
function downloadUrl(url: string, callback: (resText: string, status: number) => void) {
  let status = -1
  const request = new XMLHttpRequest()
  if (!request) {
    return
  }

  request.onreadystatechange = function () {
    if (request.readyState == 4) {
      try {
        status = request.status
      } catch {
        // Usually indicates request timed out in FF.
      }
      if (status == 200 || status == 0) {
        callback(request.responseText, request.status)
        request.onreadystatechange = () => null
      }
    }
  }
  request.open('GET', url, true)
  try {
    request.send(null)
  } catch {
    // changeStatus(e)
  }
}
